import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ProcessingService } from "libraries/service/processing/processing.service";
import { MatDialog } from "@angular/material/dialog";
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";
import { ResourceService } from "libraries/service/resource/resource.service";
import { PocModalComponent } from "app_sasha/pages/sasha-home/components/poc-modal/poc-modal.component";
import { Router } from '@angular/router';
import { SashaEntryPoints } from "app_sasha/sasha-entry-points";
import { AfidiumApps } from "app/shared/services/app-root/app-root-service";

enum ELinkEnum {
    ticketingReport = 'ticketingReport',
    importBooking = "importBooking",
}

class MyWording {
    public stateLink: string = Yii.t('wui-sasha-js', "Lister les dossiers dans l'état de caisse");
    public importLink: string = Yii.t('wui-sasha-js', "Importer des dossiers");
    public title: string = Yii.t('wui-sasha-js', "Actions");

    public external: string = Yii.t('wui-sasha-js', "Poc Flutter page externe");
    public modal: string = Yii.t('wui-sasha-js', "Poc Flutter Modale");
    public widget: string = Yii.t('wui-sasha-js', "Poc Flutter Widget");
    public loading: string = Yii.t('wui-sasha-js', "Chargement du POC en cours");
    public changeName: string = Yii.t('wui-sasha-js', "Envoi d'info dans le widget");
}

/**
 * Displays some global Sasha links.
 */
@Component({
    selector: 'sasha-side-links',
    template: `
        <card>
            <div class="card-header-content">
                <div class="title">
                    {{ labels.title }}
                </div>
            </div>
            <div class="card-body-content">
                <div *permissionIf="'sasha.booking.ticketingReport.use'">
                    <btn classList="no-spacing"
                         [label]="labels.stateLink"
                         type="actionLink"
                         (onClick)="navigateTo(links.ticketingReport)"></btn>
                </div>
                <div>
                    <btn classList="no-spacing"
                         [label]="labels.importLink"
                         type="actionLink"
                         (onClick)="navigateTo(links.importBooking)"
                         *permissionIf="'sasha.bookingImport.use'"></btn>
                </div>
            </div>
        </card>
    `,
    styles: [`
        .card-body-content {
            padding: .75rem;
        }
    `]
})
export class SashaSideLinksComponent {

    public readonly labels: MyWording = new MyWording();
    public readonly links: typeof ELinkEnum = ELinkEnum;

    constructor(
        private readonly dialog: MatDialog,
        private readonly resourceService: ResourceService,
        private readonly router: Router,
    ) {
    }

    public navigateTo(value: ELinkEnum): void {
        switch (value) {
            case ELinkEnum.ticketingReport:
                this.router.navigate([AfidiumApps.SASHA, SashaEntryPoints.bookingInTicketingReport]);
                break;
            case ELinkEnum.importBooking:
                this.router.navigate([AfidiumApps.SASHA, SashaEntryPoints.importBooking]);
                break;
            default:
                break;
        }
    }
}
